export default {
    storeApi: '/api/Vip/Public/ShopInfo', // 店铺api
    vipApi: '/api/Vip/VipInfos/GetListPaged', // 会员api
    productApi: '/api/productManagement/products', // 商品api
    guideApi: '/api/Vip/Employee', // 导购api
    rechargeApi: '/api/MarketingManagement/RechargeableCard/ItemsPaged', // 卡密api
    rechargeProductApi: '/api/MarketingManagement/RechargeableProductCard/ItemPaged', // 卡密商品api
    rechargeCouponApi: '/api/MarketingManagement/RechargeableCouponCard/ItemPaged'
}